import { motion } from "framer-motion";
import { Smartphone, Truck, Sparkles } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const ICONS = [Smartphone, Truck, Sparkles];

export default function HowItWorks() {
  const { t } = useI18n();
  return (
    <section className="dd-section bg-dd-page" data-testid="how-it-works">
      <div className="dd-container">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="dd-label text-dd-gold">{t.how.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dd-cream mt-3">{t.how.title}</h2>
          <div className="dd-ornament my-5"><span className="text-lg">✦</span></div>
          <p className="text-dd-cream-muted">{t.how.subtitle}</p>
        </div>

        <div className="relative grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {/* Connector line */}
          <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-dd-gold/50 to-transparent" />
          {t.how.steps.map((s, idx) => {
            const Icon = ICONS[idx];
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: idx * 0.12 }}
                className="relative text-center"
                data-testid={`step-${idx}`}
              >
                <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-br from-dd-gold to-[#8F6E28] text-dd-ink-dark flex items-center justify-center relative shadow-lg shadow-[rgba(201,162,76,0.35)]">
                  <Icon className="w-8 h-8" strokeWidth={1.75} />
                  <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-white border-2 border-dd-gold text-[#8F6E28] text-sm font-serif font-bold flex items-center justify-center">
                    {idx + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-2xl text-dd-cream">{s.title}</h3>
                <p className="mt-2 text-sm text-dd-cream-muted leading-relaxed max-w-[240px] mx-auto">{s.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
